import { render, staticRenderFns } from "./LoginMain.vue?vue&type=template&id=19563c41&scoped=true&"
import script from "./LoginMain.vue?vue&type=script&lang=js&"
export * from "./LoginMain.vue?vue&type=script&lang=js&"
import style0 from "./LoginMain.vue?vue&type=style&index=0&id=19563c41&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19563c41",
  null
  
)

export default component.exports